<div class="loader-overlay">
  <div class="loader-box">
    <!-- Opcional: Logo -->
    <img src="assets/img/logo.png" alt="Logo" class="logo" />

    <div class="bars-loader">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
    <p class="mensaje">{{ mensaje }}</p>
  </div>
</div>
<!--
<div
  class="container text-center"
>
  <img width="50%" height="auto" [src]="imageURL" alt="">
</div>
-->